var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("邮寄信息")))])]), _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("物流公司")
    }
  }, [_vm.readOnly ? _c("a-input", {
    attrs: {
      readOnly: _vm.readOnly
    },
    model: {
      value: _vm.mailingInfo.csCompany,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "csCompany", $$v);
      },
      expression: "mailingInfo.csCompany"
    }
  }) : _c("a-select", {
    model: {
      value: _vm.dataFrom.csCompany,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "csCompany", $$v);
      },
      expression: "dataFrom.csCompany"
    }
  }, _vm._l(_vm.logisticsSelectList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item,
        label: item
      }
    }, [_vm._v(_vm._s(item) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("运单号")
    }
  }, [_vm.readOnly ? _c("a-input", {
    attrs: {
      readOnly: _vm.readOnly
    },
    model: {
      value: _vm.mailingInfo.expressNum,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "expressNum", $$v);
      },
      expression: "mailingInfo.expressNum"
    }
  }) : _c("a-input", {
    attrs: {
      readOnly: _vm.readOnly
    },
    model: {
      value: _vm.dataFrom.expressNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "expressNum", $$v);
      },
      expression: "dataFrom.expressNum"
    }
  })], 1), _vm.accountInfo.tag == 1 ? _c("a-form-item", {
    attrs: {
      "wrapper-col": {
        span: 15,
        offset: 9
      }
    }
  }, [_vm.readOnly ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: function ($event) {
        ;
        _vm.readOnly = false, _vm.editFun();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]), !_vm.readOnly ? _c("a-button", {
    on: {
      click: function ($event) {
        ;
        _vm.readOnly = true, _vm.editFun();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };